import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { getBreadcrumbRoutes } from './helpers';
import { useProject } from '../../../contexts/ProjectContext';
import useBreadcrumbs from '../../../hooks/useBreadcrumbs';
import { isLast } from '../../../utils/utils';

const StyledBreadcrumbs = styled(MuiBreadcrumbs)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.grey[400]}`,
}));

const Breadcrumbs = ({
  instanceName,
  extensionName,
  dictionaryName,
  jobName,
  serverName,
  modelName,
  customInstName,
  assistantName,
}) => {
  const { t } = useTranslation();
  const { project } = useProject();

  // If you're getting a breadcrumb match error,
  // check to make sure you added the route to this helper function.
  const routes = getBreadcrumbRoutes(
    project?.name,
    instanceName,
    extensionName,
    dictionaryName,
    jobName,
    serverName,
    modelName,
    customInstName,
    assistantName
  );

  const breadcrumbs = useBreadcrumbs(routes);

  return (
    <StyledBreadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {breadcrumbs.map(({ match, breadcrumb, key }, i) =>
        isLast(breadcrumbs, i) ? (
          <Typography key={key} variant="caption" color="textPrimary">
            {t(breadcrumb, { ns: 'titles' })}
          </Typography>
        ) : (
          <Link
            key={key}
            component={RouterLink}
            to={match.pathname}
            color="inherit"
            variant="caption"
            underline="hover"
          >
            {t(breadcrumb, { ns: 'titles' })}
          </Link>
        )
      )}
    </StyledBreadcrumbs>
  );
};

Breadcrumbs.propTypes = {
  instanceName: PropTypes.string,
  extensionName: PropTypes.string,
  dictionaryName: PropTypes.string,
  jobName: PropTypes.string,
  serverName: PropTypes.string,
  modelName: PropTypes.string,
  customInstName: PropTypes.string,
  assistantName: PropTypes.string,
};

export default Breadcrumbs;
